export default function DirectAnswerBlock() {
  return <section id="directanswerblock" className="bg-[#E8E4DC] py-12 md:py-16">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl">
        <p className="text-lg md:text-xl font-medium text-secondary leading-relaxed text-center font-sans">
          Phenolic engraving material is a layered thermoset laminate with a colored surface cap over a contrasting core, engraved so the legend is permanent and two-color. Evermark Industrial Solutions engraves engraving-grade phenolic for control-panel legend plates, nameplates, and MIL-SPEC identification, valued for its dielectric strength, dimensional stability, and durability in industrial environments.
        </p>
      </div>
    </section>;
}